import { render } from "./SignoutView.vue?vue&type=template&id=4340dd2e"
import script from "./SignoutView.vue?vue&type=script&lang=js"
export * from "./SignoutView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nika/Sites/tanastsoroba-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__